// 列表页的显示设置：用户勾选显示哪些筛选条件（#513，决策 D187）或表格列（决策 D198），按种类与表格记在浏览器里；没记过、存储不可用或存的值不认识时用缺省。
import { useState } from "react";
import { readPref, writePref } from "@/app/storage";

/** 显示设置的种类：筛选条件或表格列。 */
export type ShownKind = "filters" | "columns";

const storageKey = (kind: ShownKind, table: string) => `axon.${kind}.${table}`;

/** 读记住的显示设置，只留 all 里认识的键；读不到、格式不对或存的全不认识（改过键名）返回 null，回到缺省。 */
function stored<K extends string>(kind: ShownKind, table: string, all: readonly K[]): K[] | null {
  try {
    const v: unknown = JSON.parse(readPref(storageKey(kind, table)) ?? "null");
    if (!Array.isArray(v)) return null;
    const known = all.filter((k) => v.includes(k));
    return known.length || !v.length ? known : null;
  } catch {
    return null;
  }
}

/** 显示的项（按 all 的顺序）与修改它的函数；改了写进浏览器存储。 */
export function useShown<K extends string>(kind: ShownKind, table: string, all: readonly K[], defaults: readonly K[]): [K[], (keys: K[]) => void] {
  const [shown, setShown] = useState<K[]>(() => stored(kind, table, all) ?? all.filter((k) => defaults.includes(k)));
  return [shown, (keys: K[]) => {
    const next = all.filter((k) => keys.includes(k));
    setShown(next);
    writePref(storageKey(kind, table), JSON.stringify(next));
  }];
}
